import React, { useCallback } from "react";
import {
  AppBar,
  Button,
  Divider,
  IconButton,
  ListItemButton,
  Stack,
  styled,
  Toolbar,
} from "@mui/material";
import Logo from "../../../Reuse/UI/Logo";
import LogoutIcon from "@mui/icons-material/Logout";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../../../context";
import { mainListItems } from "./Constant";
import { useHeaderContext } from "../Constant";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import CustomIconButton from "../../../Reuse/UI/CustomIconButton";

const Header = React.memo(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showMenu } = useHeaderContext();
  const { logout } = useAuth();
  const buttonClick = React.useCallback(() => {
    const parentPath = location.pathname.split("/").slice(0, -1).join("/");
    navigate(parentPath);
  }, [navigate, location]);
  const handleSubmit = (e) => {
    e.preventDefault();
    logout();
  };

  return (
    <AppBar elevation={0} component="nav" sx={{ background: "#FCFCFC" }}>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Logo />
        {showMenu ? (
          <React.Fragment>
            <Stack direction={"row"} gap={1}>
              {mainListItems.map((item) => (
                <Item item={item} key={item.id} />
              ))}
            </Stack>
            <Button
              variant="text"
              color="error"
              startIcon={<LogoutIcon />}
              onClick={handleSubmit}
            >
              Log out
            </Button>
          </React.Fragment>
        ) : (
          <CustomIconButton onClick={buttonClick}>
            <ClearRoundedIcon />
          </CustomIconButton>
        )}
      </Toolbar>
      <Divider />
    </AppBar>
  );
});

const ListItemButtonCustom = styled(ListItemButton)(({ theme }) => {
  return {
    [`&.Mui-selected`]: {
      background: "transparent",
      [`&::after`]: {
        content: "''",
        width: "100%",
        height: 2,
        background: "#101828",
        borderRadius: 2,
        position: "absolute",
        bottom: 0,
        left: 0,
      },
    },
  };
});

const Item = React.memo((props) => {
  const { item } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const selected = location.pathname.includes(item.check);
  const handleClick = useCallback(
    (item) => {
      navigate(`/${item.to}`);
    },
    [navigate]
  );
  return (
    <ListItemButtonCustom
      variant={"text"}
      selected={selected}
      onClick={() => handleClick(item)}
      sx={(theme) => ({
        ...theme.typography.h5,
        color: selected ? "#101828" : "#51555C",
      })}
    >
      {item.text}
    </ListItemButtonCustom>
  );
});

export default Header;
